// src/pages/HighResult.js
import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  calculateEarningRange,
  computeTopPercentile,
  getDescription,
} from "../utils";
import "./Result.css";

function HighResult() {
  // (A) 토스트 메시지
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");


  // (2) 축약 함수
  function abbreviateNumber(num) {
    // 예: 1 -> "1", 1200 -> "1.2K", 15000 -> "15K", 1,000,000 -> "1M"
    if (num < 1000) {
      return num.toString();
    } else if (num < 1_000_000) {
      // 수천 단위 (K)
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    } else if (num < 1_000_000_000) {
      // 수백만 단위 (M)
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else {
      // 수십억 단위 (B)
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    }
  }

  // (B) Location
  const { state } = useLocation();
  if (!state) {
    return (
      <div>
        Oh no! An error has occurred. Please try again. <Link to="/">Home</Link>
      </div>
    );
  }

  // (C) 기존 로직
  const { instagramId, followerCount, category, recentCollabs, campaignCost } =
    state;
  const topPercentile = computeTopPercentile(followerCount, category);
  const { minEarning, midEarning, maxEarning } = calculateEarningRange(
    followerCount,
    category,
    recentCollabs,
    campaignCost
  );
  const { title, description, image } = getDescription(topPercentile);

  // (D) 토스트 헬퍼
  const showToast = (msg) => {
    setToastMessage(msg);
    setToastVisible(true);
    setTimeout(() => setToastVisible(false), 2000);
  };

  // copy link with fallback
  const handleCopyLink = async () => {
    const copyText = "https://beautyscouter.simpleseed.ai";
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(copyText);
      } else {
        // fallback
        const tempInput = document.createElement("textarea");
        tempInput.value = copyText;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }
      showToast("Link has been copied!");
    } catch (err) {
      console.error("Error copying link:", err);
      alert("An error occurred. See console for details.");
    }
  };

  return (
    <div className="result-container">
      {/* 토스트 */}
      {toastVisible && <div className="toast-message">{toastMessage}</div>}

      {/* (1) Header */}
      <header className="result-header">
        <a
            href="../"
            target="_self"
            rel="noreferrer">
        <img
          src="https://beauty-scouter.s3.us-east-2.amazonaws.com/logo.svg"
          alt="SimpleSeed"
          className="logo"
        />
        </a>
        <button className="result-share-btn" onClick={handleCopyLink}>
          <img
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/share-orange.svg"
            alt="Share"
            className="result-share-icon"
          />
        </button>
      </header>

      {/* (2) Top% + influencer */}
      <section className="top-section">
        <div className="top-box">
          <div className="top-badge">
            <img
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Star.svg"
              alt="star"
              className="star-icon"
            />
            Top {topPercentile}%
          </div>

          <div className="influencer-inner">
            <div className="handle-pill">@{instagramId}</div>
            <div className="info-row">
              {/* Followers */}
              <div className="info-block">
                <img
                  src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Follower-orange.svg"
                  alt="Follower"
                />
                <span className="followers-text">Followers</span>
                <span className="followers">{abbreviateNumber(followerCount)}</span>

              </div>
              {/* Category */}
              <div className="info-block">
                <img
                  src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Category-orange.svg"
                  alt="Category"
                />
                <span className="category-text">{category} </span>
                <span className="category">Influencer</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* (3) Orange Box */}
      <section className="scout-box">
        <h2 className="scout-text">Your Beauty Score Has Been Scouted!</h2>
        <div className="earning-range">
          ${minEarning.toLocaleString()} ~ ${maxEarning.toLocaleString()}
          <span className="per-year">/year</span>
        </div>
        <div className="earning-sub">Estimated earnings on SimpleSeed</div>
      </section>

      {/* (4) Review */}
      <section className="review-wrap">
        <h3 className="review-title">Scouter’s Review</h3>
        {image ? (
          <img src={image} alt={title} className="review-image" />
        ) : (
          <div className="review-image-fallback" />
        )}
        <h4 className="review-grade">{title}</h4>
        <p className="review-desc">{description}</p>
      </section>

      {/* (5) Invite */}
      <section className="invite-section">
        <img
          className="invite-bg"
          src="https://beauty-scouter.s3.us-east-2.amazonaws.com/gradient.png"
          alt="BG"
        />
        <div className="invite-box">
          <img
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/(.svg"
            alt="("
          />
          <div>
            {/* 가로 배치 (Flex) */}
            <div className="invite-text-box">
              <p className="invite-strong">
                You’re in the
              </p>
              <p className="invite-strong-per">
                Top {topPercentile}%
              </p>
            </div>
            {/* 다음 줄 */}
            <p className="invite-strong" style={{ marginTop: "5px" }}>
              SimpleSeed wants to scout you!
            </p>
          </div>
          <img
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/).svg"
            alt=")"
          />
        </div>
      </section>

      {/* (6) callout-box */}
      <section className="callout-box">
        <div className="callout-star">
          <img
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Star.svg"
            alt="star"
          />
        </div>
        <p className="callout-text">
          Join forces with SimpleSeed now <br />
          and earn the <span className="callout-pill">${minEarning.toLocaleString()} ~ ${maxEarning.toLocaleString()}</span><br /> you’ve
          been missing out on.
        </p>
      </section>

      {/* (7) Collaborate... */}
      <p className="collaborate-text">
        <span className="collaborate-italic">Collaborate</span> with more brands through SimpleSeed and earn even more.
      </p>

      {/* (8) Download */}
      <section className="download-box">
        <h4 className="download-heading">
          Download <span>SimpleSeed</span>
        </h4>
        <div className="store-buttons">
          <a
            href="https://apps.apple.com/us/app/simpleseed-for-influencers/id6739995046"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/apple.svg"
              alt="App Store"
              className="store-img"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.wear.simpleseed"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/google.svg"
              alt="Google Play"
              className="store-img"
            />
          </a>
        </div>
      </section>

      {/* (9) Share section */}
      <section className="share-section">
        <div className="share-box">
          <img
            className="share-icon"
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/share-orange.svg"
            alt="Share"
          />
          <h4>Share</h4>
        </div>
        <button className="copy-btn" onClick={handleCopyLink}>
          <img
            className="copy-icon"
            src="https://beauty-scouter.s3.us-east-2.amazonaws.com/copy-orange.svg"
            alt="Copy"
          />
          Copy Link
        </button>
      </section>

      {/* (10) Disclaimer */}
      <section className="disclaimer">
        <p className="disclaimer-title">Disclaimer</p>
        <p className="disclaimer">
          All figures shown are estimates and may not reflect actual results.
        </p>
      </section>

      {/* (11) Footer */}
      <footer className="result-footer">
        <div className="footer-line" />
        <div className="footer-content">
          <div>
            <img
              className="footer-logo"
              src="https://beauty-scouter.s3.us-east-2.amazonaws.com/logo.svg"
              alt="Footer Logo"
            />
          </div>
          <div className="footer-icons">
            <a
              href="https://www.instagram.com/simpleseed/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://beauty-scouter.s3.us-east-2.amazonaws.com/IG-orange.svg"
                alt="Instagram"
                className="footer-icon"
              />
            </a>
            <a
              href="https://simpleseed.ai/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://beauty-scouter.s3.us-east-2.amazonaws.com/Home.svg"
                alt="Home"
                className="footer-icon"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HighResult;